import React from "react";
import { motion } from "framer-motion";
import {
  Sparkles,
  Award,
  Building2,
  Compass,
  Network,
  Radio,
} from "lucide-react";
import { useT } from "../i18n/LanguageProvider";

const ICONS = [Sparkles, Award, Building2, Compass, Network, Radio];

const WhyUs = () => {
  const { t, whyUs } = useT();

  return (
    <section
      id="why-us"
      className="relative py-16 md:py-24 lg:py-32 border-t border-white/5"
      data-testid="why-section"
    >
      <div className="relative max-w-[1400px] mx-auto px-5 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mb-14"
        >
          <div className="kicker mb-5">{t("why.kicker")}</div>
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-[1.05]">
            {t("why.headA")}{" "}
            <span className="text-[#39FF14] text-glow-neon">
              {t("why.headB")}
            </span>{" "}
            {t("why.headC")}
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {whyUs.map((w, i) => {
            const Icon = ICONS[i] || Sparkles;
            return (
              <motion.div
                key={w.title}
                initial={{ opacity: 0, y: 25 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.55, delay: i * 0.06 }}
                className="glass p-7 relative group"
                data-testid={`why-${i}`}
              >
                <div className="absolute top-5 right-5 font-mono text-[10px] text-white/30">
                  0{i + 1}
                </div>
                <div className="w-12 h-12 rounded-md bg-[#00E5FF]/8 border border-[#00E5FF]/25 flex items-center justify-center mb-5 group-hover:bg-[#39FF14]/10 group-hover:border-[#39FF14]/40 transition-colors">
                  <Icon className="w-6 h-6 text-[#00E5FF] group-hover:text-[#39FF14] transition-colors" />
                </div>
                <h3 className="font-heading text-xl text-white mb-2">
                  {w.title}
                </h3>
                <p className="text-sm text-[#94a3b8] leading-relaxed">
                  {w.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
